import React from 'react';
import styled from 'styled-components';

// Data for the grid elements
const elements = [
    { id: 1, title: 'Software Gestonale', description: 'Sviluppiamo software gestionali aziendali su misura per ottimizzare i processi operativi e migliorare l\'efficienza organizzativa. Le nostre soluzioni sono progettate per adattarsi alle specifiche esigenze del tuo business, integrando funzioni per la gestione delle risorse, la contabilità, il magazzino, e altri processi chiave. Grazie all\'uso di tecnologie moderne e architetture scalabili, i nostri gestionali garantiscono facilità d\'uso, affidabilità e aggiornamenti continui. Offriamo inoltre supporto personalizzato e possibilità di integrazione con sistemi esistenti, aiutandoti a centralizzare le operazioni e prendere decisioni basate su dati accurati, favorendo la crescita e l\'innovazione aziendale.', imageUrl: 'icon/gestionale-icon.png' },
    { id: 2, title: 'Data Analysis', description: 'Forniamo servizi di data analysis per trasformare i tuoi dati in informazioni strategiche, utili a migliorare le performance aziendali. Utilizziamo tecniche avanzate di analisi e strumenti all\'avanguardia per estrarre insight significativi dai dati, supportando decisioni più rapide e basate su evidenze. Offriamo soluzioni personalizzate per l\'analisi descrittiva, predittiva e prescrittiva, aiutandoti a identificare trend, ottimizzare processi e anticipare esigenze future. Con un approccio orientato ai risultati, garantiamo che i dati diventino un vero asset strategico per guidare la crescita e aumentare il vantaggio competitivo della tua azienda.', imageUrl: 'icon/dashboard-icon.png' },
    { id: 3, title: 'Data Integration', description: 'Offriamo soluzioni avanzate di data integration per connettere, consolidare e armonizzare i dati provenienti da diverse fonti aziendali. Il nostro approccio consente di integrare sistemi eterogenei in un\'unica piattaforma, migliorando la qualità dei dati e supportando decisioni strategiche più informate. Utilizziamo tecnologie moderne e best practice per garantire la sincronizzazione continua e l\'accesso in tempo reale ai dati critici, ottimizzando i flussi di lavoro e riducendo i rischi di errore. Con i nostri servizi, aiutiamo le aziende a sfruttare appieno il potenziale dei loro dati, facilitando l\'analisi, la reportistica e l\'automazione dei processi aziendali.', imageUrl: 'icon/data-integration-icon.png' },
    { id: 4, title: 'Gestione delle prenotazioni', description: 'Forniamo soluzioni complete per la gestione delle prenotazioni, progettate per semplificare e automatizzare il processo di booking. I nostri software consentono di gestire le disponibilità in tempo reale, accettare prenotazioni online, e coordinare le risorse in modo efficiente, riducendo errori e tempi di attesa. Con un\'interfaccia intuitiva e funzioni avanzate per la personalizzazione, il nostro sistema si adatta a diversi settori, dal turismo alla sanità, garantendo una gestione fluida e organizzata. Offriamo inoltre integrazioni con altri strumenti aziendali e reportistica dettagliata per monitorare le performance e ottimizzare la gestione delle attività.', imageUrl: 'icon/booking.png' },
    { id: 5, title: 'App mobile', description: 'Forniamo soluzioni complete per lo sviluppo di app mobile, progettate per soddisfare le esigenze della tua azienda e migliorare l\'interazione con gli utenti. Dall\'ideazione alla realizzazione, ci dedichiamo alla creazione di applicazioni funzionali, sicure e ottimizzate per le piattaforme iOS e Android. Utilizziamo tecnologie all\'avanguardia per garantire prestazioni elevate e integrazioni con i tuoi sistemi esistenti. Lavoriamo per offrire un prodotto finale che si distingua per usabilità e affidabilità, supportando così i tuoi obiettivi di crescita digitale.', imageUrl: 'icon/mobile-app-icon.png' },
    { id: 6, title: 'Software di calcolo', description: 'Progettiamo software di calcolo su misura, pensati per automatizzare operazioni complesse e garantire risultati accurati e affidabili. Le nostre soluzioni coprono una vasta gamma di applicazioni, dal calcolo scientifico e ingegneristico alle analisi finanziarie, ottimizzando i flussi di lavoro e riducendo gli errori manuali. Utilizziamo algoritmi avanzati e tecnologie moderne per assicurare prestazioni elevate anche con grandi volumi di dati, offrendo interfacce intuitive e funzionalità personalizzabili. I nostri software di calcolo supportano il tuo team nel prendere decisioni più rapide e precise, migliorando l\'efficienza operativa e facilitando l\'innovazione all\'interno dell\'azienda.', imageUrl: 'icon/engine-icon-2.png' },
    { id: 7, title: 'Sito Web', description: 'Offriamo servizi professionali di sviluppo di siti e portali web, progettati per soddisfare le esigenze specifiche della tua azienda. Creiamo soluzioni personalizzate, responsive e ottimizzate per garantire un\'esperienza utente fluida e coinvolgente su tutti i dispositivi. Utilizziamo le tecnologie più avanzate per costruire piattaforme sicure, veloci e scalabili, supportando il tuo business nel raggiungere i suoi obiettivi online. Dalla progettazione grafica allo sviluppo del back-end, ci occupiamo di ogni fase per consegnare prodotti di alta qualità che valorizzano la tua presenza digitale e aumentano la visibilità del tuo marchio.', imageUrl: 'icon/website-icon-1.png' },
];

const Title = styled.h3`
  text-align: center;
  margin-top: 8px; /* Aggiungi un margine superiore se necessario */
`;

const Image = styled.img`
  max-width: 25%;
  min-width: 60px;
  height: auto;
  border-radius: 8px;
  margin-bottom: 8px;
`;

// Styled components for styling
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  width: 60%;
  margin: 0 auto;
  ${Image} {
    width: 100%; // Set your desired width
  }
  padding-top: 30px;
  padding-bottom: 30px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Su schermi piccoli, un'unica colonna */
    width: 80%; /* Imposta la larghezza al 100% per occupare tutto lo spazio disponibile */
    padding-left: 10px; /* Aggiungi un po' di padding sui lati */
    padding-right: 10px; 
  }
`;

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fafafa; /* Set your desired background color */

`;

const CenteredGridItem = styled(GridItem)`
  width: 100%; /* Imposta la larghezza al 100% della colonna */
  max-width: calc(50% - 8px); /* Riduci la larghezza totale tenendo conto del gap */
  min-width: 285px; /* Riduci la larghezza totale tenendo conto del gap */
  grid-column: span 2; /* Occupa due colonne quando possibile */
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    grid-column: span 1; /* Su una sola colonna in particolare centra sempre */
    width: 100%;
  }
`;

// React component
const GridPage = () => {
    return (
        <GridContainer>
            {elements.map((element) => (
                element.id === 7 ? (
                    <CenteredGridItem key={element.id} id={`servizio-${element.id}`}>
                        <Image src={element.imageUrl} alt={element.title} />
                        <Title>{element.title}</Title>
                        <p>{element.description}</p>
                    </CenteredGridItem>
                ) : (
                    <GridItem key={element.id} id={`servizio-${element.id}`}>
                        <Image src={element.imageUrl} alt={element.title} />
                        <Title>{element.title}</Title>
                        <p>{element.description}</p>
                    </GridItem>
                )
            ))}
        </GridContainer>
    );
};

export default GridPage;